<template>
    <div class="q-dashboard q-dashboard--mobile ">
        <v-container fluid class="q-dashboard__content px-5">
            <v-row class="mb-4">
                <v-col cols="12" class="d-flex align-content-center flex-wrap px-5" style="position:relative;">
                    <q-page-slider class="q-page-slider" height="auto" :slug="current_tenant.ID + '-homepage-slider'" ref="sliderpage"></q-page-slider>
                </v-col>
                <v-col v-if="tenantHasFeature('Contests', current_tenant.ID)">
                    <v-btn to="/contests" color="black" depressed dark width="100%" class="text-none">
                        Contests
                    </v-btn>
                </v-col>
                <v-col v-if="tenantHasFeature('News', current_tenant.ID)">
                    <v-btn to="/news" color="black" depressed dark width="100%" class="text-none">
                        News
                    </v-btn>
                </v-col>
                <v-col v-if="tenantHasFeature('Events', current_tenant.ID)">
                    <v-btn to="/events" color="black" depressed dark width="100%" class="text-none">
                        Events
                    </v-btn>
                </v-col>
            </v-row>
            <div class="q-dashboard__links">
                <v-btn v-for="(nav_item, k) in filtered_menu" :key="k" @click="goTo(nav_item)" :color="nav_item.hex_color ? nav_item.hex_color : '#ff0000'" class=" mb-2 text-none" depressed dark width="100%">{{nav_item.label}}</v-btn>
            </div>
        </v-container>
        <div class="q-dashboard__search-bar px-5">
            <QSearchInput />
            <v-icon class="ml-2" v-text="'fas fa-search'" />
        </div>
    </div>
</template>
<script>
import QPageSlider from '@/components/utils/QPageSlider.vue';
import QSearchInput from '@/components/utils/QSearchInput.vue';

export default {
    name: 'DashboardMobile',

    components: {
        QPageSlider,
        QSearchInput,
    },
    computed: {
        filtered_menu: function() {
            var m = [];
            var g = this;
            this.user.nav_menu.forEach(function(item) {
                if (g.current_tenant.ID == item.tenant_id && item.menu == 'Mobile Home') {
                    var _item = { ...item }
                    _item.children = [];
                    item.children.forEach(function(child) {
                        if (g.current_tenant.ID == child.tenant_id) {
                            _item.children.push(child)
                        }
                    })
                    m.push(item);
                }
            })
            return m
        },
    },
    methods: {
        goTo(target) {
            if (target.to) {
                this.$router.push(target.to)
            }
            if (target.href) {
                window.open(target.href, '_blank');
            }
            if (target.link) {
                window.open(target.href, '_blank');
            }
            if (target.fun) {
                target.fun();
            }
        },
    }
};
</script>
<style lang="scss">
.q-dashboard {
    height: 100%;

    &--mobile {
        display: flex;
        flex-direction: column;
    }

    &__content {
        flex: 1;
    }

    &__search-bar {
        display: flex;
        background: #F4F4F4;
    }
}
</style>